import React from "react";
import { MessagePure, ButtonHLPure, DialogSystemGLPure, HeaderHLPure } from "../../pures";
import "./request-otp.css";

const RequestOTPView = (props) => {
    let {
        t,
        showLoadingRequesting,
        toggleErrorRequesting,
        showCompletedRequesting,
        toggleLoadingRequesting,
        toggleCompletedRequesting,
        showErrorRequesting,
        showWarningRequesting,
        messageComplete,
        messageError,
        messageWarning,
        phoneNumber,
        validationCode,
        inputOTP,
        focusedOTP,
        handleClickOTP,
        handleFocusOTP,
        handleBlurOTP,
        handleChangeOTP,
        handleKeyUpOTP,
        resendSMSOrEmail,
        handleBackView,
        handleValidateCode,
        userEmail,
    } = props

    return (
        <div className="requestotpview-wrapper">
            <div className="requestotpview-container">
                <div className="requestotpview-header">
                    <HeaderHLPure title={t("requestotpview.header.title")} />
                </div>
                <div className="requestotpview-body">
                    <div className="requestotpview-items">
                        <MessagePure
                            {...props}
                            input={inputOTP}
                            onReSendMessage={(e, validationType) => resendSMSOrEmail(e, validationType)}
                            validationCode={validationCode}
                            focused={focusedOTP}
                            cellphoneNumber={phoneNumber}
                            description={t("requestOTPView.description", { userEmail })}
                            handleClick={(e) => handleClickOTP(e)}
                            handleFocus={(e) => handleFocusOTP(e)}
                            handleBlur={(e) => handleBlurOTP(e)}
                            handleChange={(e) => handleChangeOTP(e)}
                            handleKeyUp={(e) => handleKeyUpOTP(e)}
                            onlyEmail={true}
                            labelBtnOnlyEmail={t("messagePure.send.email.only.email")}
                            labelTitle={t("messagePure.title.only.email")}
                            onBack={handleBackView}
                            labelBackBtn={t("button.return")}
                            onVerify={handleValidateCode}
                        />
                    </div>
                </div>
                <DialogSystemGLPure
                    showLoadingRequesting={showLoadingRequesting}
                    toggleLoadingRequesting={toggleLoadingRequesting}

                    showCompletedRequesting={showCompletedRequesting}
                    toggleCompletedRequesting={toggleCompletedRequesting}
                    messageComplete={messageComplete}

                    showErrorRequesting={showErrorRequesting}
                    toggleErrorRequesting={toggleErrorRequesting}
                    messageError={messageError}

                    showWarningRequesting={showWarningRequesting}
                    messageWarning={messageWarning}
                />
            </div>
        </div>
    )
}

export { RequestOTPView as default }